import { Component } from '@angular/core';

@Component({
  selector: 'fnsr-imprint',
  standalone: true,
  templateUrl: './imprint.component.html'
})
export class ImprintComponent {

}
